import { DialogContent } from "@/view/components/ui/dialog";

import PersonalInfoForm from "@/view/pages/Dashboard/components/Simulations/Crefaz/PersonalInfo/components/PersonalInfoForm";
import AddressForm from "@/view/pages/Dashboard/components/Simulations/Crefaz/PersonalInfo/components/AddressForm";
import ContactReferencesForm from "@/view/pages/Dashboard/components/Simulations/Crefaz/PersonalInfo/components/ContactReferencesForm";
import BankInfoForm from "@/view/pages/Dashboard/components/Simulations/Crefaz/PersonalInfo/components/BankInfoForm";
import Steps from "@/view/pages/Dashboard/components/Simulations/Crefaz/PersonalInfo/components/Steps";

import ProposalSuccess from "./components/ProposalSuccess";
import usePersonalInfo from "./usePersonalInfo";
import { FormProvider } from "react-hook-form";
import Header from "./components/Header";

  interface PersonalInfoProps {
    onBack: () => void;
    onFinish?: () => void;
  }

  export default function PersonalInfo({ onBack, onFinish }: PersonalInfoProps) {
    const { steps, title, form, step, setStep } = usePersonalInfo();

    function handleBack() {
      if (step > 0) {
        setStep(step - 1);
      } else {
        onBack();
      }
    }

  return (
    <DialogContent 
      className={
        step === 5
          ? "max-w-[560px]"
          : step < 3
            ? "min-w-[896px]"
            : "min-w-[760px]"
      }
      onInteractOutside={(event) => {
        if (step === 5) {
          event.preventDefault();
        }
      }}
    >
      <div className={step < 5 ? "" : "hidden"}>
        {step < 4 && <Header title={title[step]} onBack={handleBack} />}
        <Steps visible={step < 4} />
        <form {...form}>
          <FormProvider {...form}>
            <PersonalInfoForm visible={steps.personalInfo} />
            <AddressForm visible={steps.address} />
            <ContactReferencesForm visible={steps.contactReferences} />
            <BankInfoForm visible={steps.bankInfo} />
            <ProposalSuccess visible={steps.success} onClose={onFinish || onBack} />
          </FormProvider>
        </form>
      </div>
    </DialogContent>
  );
}
